import { useState } from 'react'
import { addMoneySimbols } from '@/app/utils/formatMoneyValue'
import { formatDate } from '@/app/utils/formatDate'
import { ChevronDown } from 'lucide-react'
import { TableInstallmentProps } from '../Installments/components/types'

interface ItemProps {
  label: string
  value: string
}
const Item = ({ label, value }: ItemProps) => {
  return (
    <div className="flex justify-between py-1">
      <span className="text-black05 font-medium">{label}</span>
      <span className="font-semibold text-black01">{value}</span>
    </div>
  )
}
interface InstallmentsTaxProps {
  currentTable: TableInstallmentProps
  onAlterarClick?: () => void
}

const InstallmentsTax = ({
  currentTable,
  onAlterarClick,
}: InstallmentsTaxProps) => {
  const [open, setOpen] = useState(false)

  const items = [
    {
      label: 'Valor Solicitado',
      value: addMoneySimbols(currentTable.ValorSolicitado ?? 0),
    },
    {
      label: 'Valor Bloqueado',
      value: addMoneySimbols(currentTable.ValorBloqueado ?? 0),
    },
    // {
    //   label: 'Taxa de Cadastro',
    //   value: '-' + addMoneySimbols(currentTable.ValorTC ?? 0),
    // },
    { label: 'IOF', value: '-' + addMoneySimbols(currentTable.IOF ?? 0) },
    // {
    //   label: 'Seguro',
    //   value: '-' + addMoneySimbols(currentTable.ValorSeguro ?? 0),
    // },
  ]

  return (
    <>
      <div className="mb-8 flex flex-col items-center">
        <span className="text-base font-semibold text-black01">
          Saldo disponível
        </span>
        <div className="mt-2 flex items-center gap-2">
          <span className="text-3xl font-semibold text-black01 sm:text-4xl">
            {addMoneySimbols(currentTable.ValorLiquidoCliente ?? 0)}
          </span>
          {onAlterarClick && (
            <button
              className="ml-2 rounded-full bg-primary/20 px-3 py-1 text-xs font-semibold text-primary hover:bg-gray01 sm:text-sm"
              onClick={onAlterarClick}
            >
              Alterar
            </button>
          )}
        </div>
        <span className="mt-2 text-sm font-medium text-black04 sm:text-base">
          {currentTable.Prazo || 0} parcelas, de{' '}
          {currentTable.DataPrimeiroVencimento
            ? formatDate(currentTable.DataPrimeiroVencimento)
            : ''}{' '}
          a{' '}
          {currentTable.DataUltimoVencimento
            ? formatDate(currentTable.DataUltimoVencimento)
            : ''}
        </span>
      </div>
      <div className="mb-6">
        <button
          className={`flex w-full items-center justify-between px-5 py-3 text-base font-bold sm:text-lg ${open ? 'rounded-t-xl bg-black03 text-white' : 'rounded-xl bg-zinc-800 text-white hover:bg-zinc-900'}`}
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
          aria-controls="installments-dropdown"
        >
          {open ? 'Parcelas' : 'Parcelas e taxas'}
          <span
            className={`ml-2 transition-transform ${open ? 'rotate-180' : ''}`}
          >
            <ChevronDown />
          </span>
        </button>
        <div
          id="installments-dropdown"
          className={`overflow-hidden transition-all duration-300 ${open ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'}`}
        >
          {open && currentTable.Parcelas && (
            <div className="rounded-b-xl bg-black03 p-4 text-white01">
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead className="border-b border-t border-gray02">
                    <tr className="text-black04">
                      <th className="px-2 py-1 text-left">Nº</th>
                      <th className="px-2 py-1 text-left">Venc</th>
                      <th className="px-2 py-1 text-left">Parcela</th>
                      <th className="px-2 py-1 text-left">Val princ</th>
                      <th className="px-2 py-1 text-left">Juros</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentTable.Parcelas.map((p) => (
                      <tr key={p.NumeroParcela} className="text-xs">
                        <td className="px-2 py-1">{p.NumeroParcela}</td>
                        <td className="px-2 py-1">
                          {formatDate(p.DataVencimento)}
                        </td>
                        <td className="px-2 py-1">
                          {addMoneySimbols(p.ValorParcela)}
                        </td>
                        <td className="px-2 py-1">
                          {addMoneySimbols(p.ValorPrincipal)}
                        </td>
                        <td className="px-2 py-1">
                          {addMoneySimbols(p.ValorJuros)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {currentTable.Taxas && (
                <div className="mt-6">
                  <div className="mb-2 text-base font-bold">Taxas</div>
                  <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                      <thead className="border-b border-t border-gray02">
                        <tr className="text-black04">
                          <th className="px-2 py-1 text-left">Nome</th>
                          <th className="px-2 py-1 text-left">Mensal (AM)</th>
                          <th className="px-2 py-1 text-left">Anual (AA)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentTable.Taxas.map((t) => (
                          <tr key={t.name} className="text-xs font-semibold">
                            <td
                              className={`px-2 py-1 font-semibold ${t.name.toLowerCase().includes('ap') || t.name.toLowerCase().includes('nominal') || t.name.toLowerCase().includes('cliente') || t.name.toLowerCase().includes('cet') ? 'text-primary' : ''}`}
                            >
                              Taxa {t.name}
                            </td>
                            <td className="px-2 py-1">{t.mensal}%</td>
                            <td className="px-2 py-1">{t.anual}%</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>

        <div className="mb-8 mt-2 rounded-xl bg-zinc-100 px-5 py-4 text-sm ">
          {items.map((i) => (
            <Item key={i.label} {...i} />
          ))}
        </div>
      </div>
    </>
  )
}

export default InstallmentsTax
